<template>
  <div class="maindiv sindex-wrap sindex_main">
    <div class="ht200 sindex-bg"></div>

    <div class="newsdiv wd1200 pt25 fs0 pb30">
      <!-- 通知公告 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=1&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-schange img-bg dinline-block vbottom"></span>
              通知公告
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.notice">
            <practice-article-row v-for="item in info.notice" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=1&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>

      <!-- 新闻速递 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=2&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-splan img-bg dinline-block vbottom"></span>
              新闻速递
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.news">
            <practice-article-row v-for="item in info.news" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=2&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>

      <!-- 实习岗位 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=3&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-sproblem img-bg dinline-block vbottom"></span>
              实习岗位
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.internship_jobs">
            <practice-article-row v-for="item in info.internship_jobs" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=3&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>
    </div>

    <div class="newsdiv wd1200 pt25 fs0 pb30">
      <!-- 招聘公告 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=4&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-schange img-bg dinline-block vbottom"></span>
              招聘公告
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.recruitment_notice">
            <practice-article-row v-for="item in info.recruitment_notice" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=4&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>

      <!-- 招聘会 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=5&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-splan img-bg dinline-block vbottom"></span>
              招聘会
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.recruitment_fair">
            <practice-article-row v-for="item in info.recruitment_fair" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=5&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>

      <!-- 全职岗位 -->
      <div class="notices wd380 dinline-block vtop br2">
        <div class="st pb10">
          <router-link to="/practice/article/list?id=6&pid=2" class="more fr tc6 br30 mt5 trans3 fs14 mt10">更多 +</router-link>
          <div class="dinline-block">
            <div class="fs24 mr5 dinline-block prelative">
              <span class="img-sdown img-bg dinline-block vbottom"></span>
              全职岗位
            </div>
          </div>
        </div>
        <div class="border-red ht350 pt15 pl15 pr10">
          <template v-if="info.full_time_jobs">
            <practice-article-row v-for="item in info.full_time_jobs" :key="item.id" :item="item"
              @click="$router.push(`/practice/article/detail?id=6&pid=2&article_id=${item.id}`)" />
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PracticeArticleRow from '@/components/practice/ArticleRow'

export default {
  name: "practiceIndex",
  components: {
    PracticeArticleRow
  },
  data(){
    return {
      info:{}
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      this.$request.get('practice-home',[],response => {
        if(response.data.code == 200){
          this.info = response.data.data
        }
        console.log(this.info)
      },error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  .sindex-bg{background: url(../../assets/images/sindex_01.jpg) no-repeat center top}
  .sindex-wrap .notices .sdiv,.snotice-wrap .notives .sdiv{height: 35px;line-height: 35px;}
  .sindex-wrap .newsdiv .notices:nth-child(2){margin: 0 30px;}
  .img-schange{background: url(../../assets/images/scn1.png) no-repeat -60px -280px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-sproblem{background: url(../../assets/images/scn1.png) no-repeat -60px -448px;}
  .img-sdown{background: url(../../assets/images/scn1.png) no-repeat -60px -528px;}
  .menu{width: 930px;margin-top:0;}
</style>



// WEBPACK FOOTER //
// src/pages/practice/index.vue